import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_FAILED,
  CREATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILED,
  DELETE_CATEGORY_SUCCESS,
  DISABLE_CATEGORY,
  DISABLE_CATEGORY_FAILED,
  DISABLE_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILED,
  GET_CATEGORIES_SUCCESS,
  ON_SEARCH_CATEGORY,
  RESET_FORM_CATEGORY,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_FAILED,
  UPDATE_CATEGORY_SUCCESS,
} from './constants';

const initialState = {
  categoryList: [],
  categoryFilteredList: [],
  inputSearch: '',
  error: null,
  success: undefined,
  loading: false,
};

const categoryReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_CATEGORIES:
      return { ...state, loading: true };
    case GET_CATEGORIES_SUCCESS: {
      const { categories } = action.payload;
      return {
        ...state,
        categoryList: categories,
        loading: false,
      };
    }
    case GET_CATEGORIES_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case CREATE_CATEGORY:
      return { ...state, loading: true };
    case CREATE_CATEGORY_SUCCESS: {
      const { category } = action.payload;
      return {
        ...state,
        categoryList: [category, ...state.categoryList],
        categoryFilteredList: [],
        inputSearch: '',
        loading: false,
      };
    }
    case CREATE_CATEGORY_FAILED: {
      const { error } = action.payload;
      return { ...state, error, loading: false };
    }

    case UPDATE_CATEGORY:
      return { ...state, loading: true };
    case UPDATE_CATEGORY_SUCCESS: {
      const { category } = action.payload;
      return {
        ...state,
        categoryList: state.categoryList.map((i) => (i.id === category.id ? { ...category } : i)),
        categoryFilteredList: [],
        inputSearch: '',
        loading: false,
      };
    }
    case UPDATE_CATEGORY_FAILED: {
      const { error } = action.payload;
      return { ...state, error, loading: false };
    }

    case DISABLE_CATEGORY:
      return { ...state, loading: true };
    case DISABLE_CATEGORY_SUCCESS: {
      const { category } = action.payload;
      return {
        ...state,
        loading: false,
        categoryList: state.categoryList.map((i) => (i.id === category.id ? { ...category } : i)),
        categoryFilteredList: state.categoryList.map((i) =>
          i.id === category.id ? { ...category } : i,
        ),
      };
    }
    case DISABLE_CATEGORY_FAILED: {
      const { error } = action.payload;
      return { ...state, error, loading: false };
    }

    case DELETE_CATEGORY:
      return { ...state, loading: true };
    case DELETE_CATEGORY_SUCCESS: {
      const { categoryId } = action.payload;
      return {
        ...state,
        loading: false,
        categoryList: state.categoryList.filter((i) => i.id !== categoryId),
        categoryFilteredList: state.categoryList.filter((i) => i.id !== categoryId),
      };
    }
    case DELETE_CATEGORY_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case RESET_FORM_CATEGORY:
      return { ...state, ...initialState };
    case ON_SEARCH_CATEGORY: {
      const { text } = action.payload;
      const categoryFilteredList = [];
      state.categoryList.forEach((item) => {
        const name = item.name.toLowerCase();
        if (name.search(text.toLowerCase().trim()) !== -1) categoryFilteredList.push(item);
      });
      return { ...state, categoryFilteredList, inputSearch: text };
    }
    default:
      return state;
  }
};

export default categoryReducer;
